export default __webpack_public_path__ + "static/sustainability_hero-5f2beb0c27286f81d5ec95d369e20485.jpg";